define(
    'checkPreInit/verifySession',['atn/atn', 'dataSource/session','./loadingErrors'],
    function(atn, session, errors) {
        'use strict';

        var sessionStaircase = atn.utils.createWaterfall([
            casRedirectSetSession,fetchSessionInfo
        ]);

        return {
            sessionStaircase: sessionStaircase,
            fetchSessionInfo: fetchSessionInfo,
            casRedirectSetSession:casRedirectSetSession
        };

        function casRedirectSetSession(data, next){
            var sessionCreatePromise;
            var urlParts = atn.utils.parseURL(window.location.href);
            var ticket = urlParts.query.ticket;
            if(ticket && atn.dataCache.getLocalStorageVariable('ticketKey') === ticket){
                next();
            } else if(ticket && atn.dataCache.getLocalStorageVariable('ticketKey') !== ticket){
                
                sessionCreatePromise = session.setSession(ticket);
                sessionCreatePromise.done(function(response){
                    atn.dataCache.setLocalStorageVariable('ticketKey',ticket);
                    data.customerId= response.customerId;
                    data.firstName = response.firstName;
                    data.hasRightsOnAllCustomers= response.hasRightsOnAllCustomers;
                    data.lastName=  response.lastName;
                    data.role= response.role;
                    data.userId = response.userId;
                    next();
                });
                sessionCreatePromise.fail(function(xhr){
                    //check status and perform action here
                    if(xhr.status === 403){
                        next(errors.INVALID_TICKET);
                    } else if (xhr.status === 500 || xhr.status === 503){
                         next(errors.CAS_SESSION_CREATE_FAILURE);
                    }else {
                        next();
                    }
                });
            } else {
                next();
            }
                
        }

        function fetchSessionInfo(data, next) {
            var sessionPromise = session.getSession(true),
                errorParam = {};

            sessionPromise.done(function(response){
                data.user = response.user;
                data.role = response.role;
                data.hasRightsOnAllCustomers = response.hasRightsOnAllCustomers;
                next();  
            });
            sessionPromise.fail(function(xhr) {
                //!ToDo handle 500 case hers
                if(xhr.status === 404){
                    errorParam.errorDescObj = {};
                    errorParam.errorDescObj.redirectUrl= xhr.responseJSON.redirectUrl;
                    errorParam.errorAction = errors.CAS_LOGIN;
                    next(errorParam);
                } else if (xhr.status === 500){
                    errorParam.errorDescObj = {};
                    errorParam.errorDescObj.message= xhr.responseJSON.message;
                    errorParam.errorAction = errors.NO_SSO_BACKEND;
                    next(errorParam);
                }  else if (xhr.status === 503){
                    next(errors.CAS_SESSION_CREATE_FAILURE);
                } else{
                    next();
                }
            });
        }
    }
);
